import "@elements/dom-utils/polyfills/ie";
import {findAll, on } from "@elements/dom-utils";
import {onFind} from "@elements/init-modules-in-scope";

import * as toc from '@elements/toc';
toc.init({linkClass: 'visually-hidden-focusable'});

import * as lazyImg from '@elements/lazy-img';
lazyImg.init({preventNative: true});

import * as playVideo from './play-video';
playVideo.init();

import * as nav from './nav';
nav.init();

import * as renderTemplate from './render-template';
renderTemplate.init();

import * as logoToggle from './logo-toggle';
logoToggle.init();

import 'bootstrap/js/dist/collapse';

import * as shariff from './shariff';
shariff.init();

import { init } from "@elements/cookie-permissions/bootstrap-5";
if (!_config.admin && !_config.editmode) {
    init();
}

import { showCookiesSettings } from "@elements/cookie-permissions";
findAll('.js-show-cookie-modal').map(on('click', showCookiesSettings));

import Dropdown from 'bootstrap/js/dist/dropdown';
onFind('[data-bs-toggle="dropdown"]',function (element) {
    new Dropdown(element);
});